const trendingItems = [
  {
    name: "Bags",
    subtitle: "Designer finds at unbeatable prices",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Designer%20handbags%20and%20totes%20in%20warm%20lighting%20on%20minimalist%20cream%20surface%2C%20artistic%20editorial%20photography%2C%20soft%20shadows%2C%20luxury%20fashion%20aesthetic%2C%20organic%20texture%2C%20warm%20beige%20tones&width=800&height=1067&seq=trend-bags&orientation=portrait",
  },
  {
    name: "Belts",
    subtitle: "Premium leather essentials",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20leather%20belts%20artfully%20arranged%20on%20clean%20beige%20backdrop%2C%20warm%20studio%20lighting%2C%20minimalist%20product%20photography%2C%20soft%20natural%20textures%2C%20editorial%20fashion%20style&width=800&height=1067&seq=trend-belts&orientation=portrait",
  },
  {
    name: "Perfumes",
    subtitle: "Signature scents curated for you",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20perfume%20bottles%20with%20warm%20amber%20lighting%20on%20cream%20marble%20surface%2C%20luxury%20beauty%20editorial%20photography%2C%20soft%20natural%20light%2C%20sophisticated%20minimalist%20aesthetic%2C%20warm%20neutral%20tones&width=800&height=1067&seq=trend-perfumes&orientation=portrait",
  },
];

export default function TrendingFinds() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            Trending Finds
          </p>
          <p className="text-sm md:text-base text-foreground-500 font-label max-w-md mx-auto">
            Hand-picked categories our community is loving right now
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {trendingItems.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-2xl overflow-hidden aspect-[3/4] cursor-pointer"
            >
              <img
                src={cat.imageUrl}
                alt={cat.name}
                className="absolute inset-0 w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <h3 className="text-white text-xl md:text-2xl font-heading font-bold mb-1">
                  {cat.name}
                </h3>
                <p className="text-white/75 text-xs md:text-sm font-label">
                  {cat.subtitle}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}